import { LecturerScheduleTable } from '../componenets/lecturer-schedule/lecturer-schedule-table';
import { Dialog } from 'primereact/dialog';
import { AddNewProtectors } from '../componenets/add-new-protector-dialog/add-new-protectors';
import { CreateCalendarScheduleDialog } from '../../../../../../calendar/create-calendar-schedule-dialog';
import { StudentsEnrollment } from '../componenets/students-enrollment/students-enrollment';
import React, { useState } from 'react';
import {
  ClassSchedule,
  ExamMetadata,
  ExamSessionDetails,
} from '../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { SelectedSlotsState } from '../../../../../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import { LecturerIdWithActivityTypeId } from '../../../../../../calendar/tabs/serial/create-lecture-serial-tab';
import { Button } from 'primereact/button';
import globalProgramStore from '../../../../../../../stores/program-store';

interface ExamPageAll {
  sessionsDetails: ExamSessionDetails[];
  selectedSessionIndex: number;
  setSessionDetails: (sessionDetails: ExamSessionDetails[]) => any;
  setClassSchedule: (classSchedule: ClassSchedule | null) => any;
  classSchedule: ClassSchedule | null;
  setAddSchedule: (loading: boolean) => any;
  addSchedule: boolean;
  onApprove: (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
  ) => any;
  examDetails: ExamMetadata;
}

export const ExamPageAll: React.FC<ExamPageAll> = ({
  sessionsDetails,
  selectedSessionIndex,
  setSessionDetails,
  setClassSchedule,
  classSchedule,
  setAddSchedule,
  addSchedule,
  onApprove,
  examDetails,
}) => {
  return (
    <div>
      <Button label={'הוספת שיבוץ'} onClick={() => setAddSchedule(true)} />
      {sessionsDetails[selectedSessionIndex]?.classesSchedule.map((item) => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <LecturerScheduleTable
            protectors={item.protectors}
            displayHeader={true}
            setClassSchedule={setClassSchedule}
            classSchedule={item}
          />
        </div>
      ))}

      <Dialog
        header="הוספת משגיח"
        visible={!!classSchedule && !!sessionsDetails}
        style={{
          height: '70vh',
          width: '80vw',
          backgroundColor: 'white',
          padding: '8px',
          borderRadius: '8px',
        }}
        onHide={() => setClassSchedule(null)}
      >
        {!!classSchedule &&
          !!sessionsDetails &&
          sessionsDetails[selectedSessionIndex].id && (
            <AddNewProtectors
              examId={examDetails.id}
              sessionId={sessionsDetails[selectedSessionIndex].id}
              classId={classSchedule.classId}
              setExamDetails={setSessionDetails}
              onHide={() => setClassSchedule(null)}
            />
          )}
      </Dialog>

      {addSchedule && (
        <CreateCalendarScheduleDialog
          branchId={
            globalProgramStore.programs.get(globalProgramStore.getCurrentId())
              .metadata.branchId
          }
          courseName={'asd'}
          onApprove={onApprove}
          supportMultiple={true}
          timeSlot={{ start: new Date(), end: new Date(), classId: 3 }}
          onHide={() => setAddSchedule(false)}
        />
      )}

      <StudentsEnrollment
        examDetails={examDetails}
        examSession={sessionsDetails[selectedSessionIndex] ?? null}
        setExamDetails={setSessionDetails}
      />
    </div>
  );
};
